/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBakingWithKidsTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBakingWithKids,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Bake with the Kids!",
    "Baking with Kids Workshop Awaits!",
    "Fun in the Kitchen Together!",
  ],
  title: "Baking with Kids",
  description: "Organize a fun baking workshop for kids.",
  longDescription:
    "Gather your friends and their kids for an exciting baking workshop! Choose a date, decide on fun recipes, and plan activities!",
  emoji: "🍪",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Baking with Kids",
          emoji: "🍪",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the baking with kids workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on fun recipes to bake?",
            description: "What recipes should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What recipes should we consider?",
                emoji: "🧁",
                completeAction: {
                  question: "Decide on ingredients needed?",
                  description: "What ingredients should we gather for baking?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What ingredients should we bring?",
                      emoji: "🥚",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Bake Together!",
    outroDescription:
      "Your baking with kids plans are set! Enjoy the fun in the kitchen!",
  },
};
